export const LOGINREQUEST = "LOGINREQUEST"
export const LOGINFAILURE = "LOGINFAILURE"
export const LOGINSUCCESS = "LOGINSUCCESS"